//############################################################################
// App
//############################################################################

// Alpine
//------------------

import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";
import collapse from "@alpinejs/collapse";
import persist from "@alpinejs/persist";

// Components
//---------

import productSelector from "./components/_productSelector";
import productShortlist from "./components/_productShortlist";

Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.plugin(persist);

window.Alpine = Alpine

document.addEventListener("alpine:init", () => {    
  Alpine.store("productShortlist", {
    shortlist: Alpine.$persist([]).as("productShortlist"),
    shortlistOpen: false,
    toggleShortlist() {
      this.shortlistOpen = !this.shortlistOpen;
    },
    add(id) {
      this.shortlist.push(id);
    },
    remove(id) {
      this.shortlist.splice(this.shortlist.indexOf(id), 1);
    },
    clear() {
      this.shortlist = [];
    },
  });

  Alpine.data("productSelector", productSelector);
  Alpine.data("productShortlist", productShortlist);
});

Alpine.start()

// Handle back/forward reload
//------------------

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.reload(true);
  }
})


// Polyfills
//------------------

import './polyfills/polyfills'

// Vendor
//------------------

import './vendor/vendor'

// Components
//------------------

import './components/components'

// Utilities
//------------------

import './utilities/utilities'

